"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function HeaderNavigation({ children }) {
    return (0, jsx_runtime_1.jsx)("ul", { className: "usa-nav__primary usa-accordion", children: children });
}
exports.default = HeaderNavigation;
